module.exports = __webpack_public_path__ + "img/BeccaPalette2.859203d5.jpg";